import React, { Component } from 'react';
import SweetAlert from 'react-bootstrap-sweetalert';
import ReactLoading from 'react-loading'

class SweetAlertExt extends Component {

  constructor(props) {
    super(props);
  }

  render() {

    let cloneProps = Object.assign({}, this.props);

    let reactLoadingStyle = {position: 'absolute', right: '0px', top: '25px', transform: 'translate(-50%,-50%)', fill: "#333333", width: '30px', height: '30px'};
    reactLoadingStyle = Object.assign(reactLoadingStyle, this.props.reactLoadingStyle || {});

    let topComponent;

    if (this.props.loading) {
      topComponent = (
        <div style={{left: 0, top: 0, position: 'absolute', width: '100%', height: '100%', backgroundColor: '#00000000'}}>
          <ReactLoading type="spin" style={reactLoadingStyle}/>
        </div>);
    }


    return <SweetAlert type="custom" {...cloneProps} customIcon={topComponent}/>
  }
}

export default SweetAlertExt;
